export const REMOVE_AUTH_HEADER = 'py-remove-authorization-header';
